module.exports = __webpack_public_path__ + "img/icon_informed_delivery.a68eb597.svg";